/**
 * Sort product types case-insensitively by title.
 * Does not mutate the input array.
 * @param {Array<{title: string}>} items
 * @returns {Array<{title: string}>}
 */
export const sortByTitle = (items) => [...items].sort(
  (a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }),
);

export default sortByTitle;
